import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import Left from "../../assets/icons/left.svg";
import Download from "../../assets/icons/download.svg";
import Right from "../../assets/icons/right.svg";
import Misc1 from "../../assets/misc/14.svg";
// import Misc2 from "../../assets/misc/10.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Timeline = () => {
  const sliderRef = useRef();
  const [index, setIndex] = useState(0);

  const settings = {
    infinite: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    initialSlide: index,
    swipe: false,
  };

  const items = [
    {
      title: "Call for applications",
      description:
        "Applications for the Hackathon will start being accepted. Please follow this page and our socials for more updates.",
      date: "26th September 2022",
      presentation: false,
      video: false,
    },
    {
      title: "Introduction to the Competition",
      description:
        "Learn the premise of the competition, the basics of input and output privacy, why PETs are of critical importance and the work of the UN PET Lab.",
      date: "19th October 2022",
      presentation: false,
      video: false,
    },
    {
      date: "26th October 2022",
      title: "Overview of PET Frameworks",
      description:
        "Learn from the core developers of Oblivious, OpenDP, SmartNoise and DiffPrivLib. See how they work and how you can use them in the competition. Live Q&A.",
      links: true,
      presentation: false,
      video: false,
      links_description: () => 
        <p>
          Learn from the core developers of 
          <a href="https://www.oblivious.ai/" target={"__blank"} className="text-blue-700 hover:text-blue-900 cursor-pointer font-medium"> Oblivious</a>
          , <a href="https://github.com/opendp/opendp" target={"__blank"} className="text-blue-700 hover:text-blue-900 cursor-pointer font-medium"> OpenDP</a>
          , <a href="https://github.com/opendp/smartnoise-sdk" target={"__blank"} className="text-blue-700 hover:text-blue-900 cursor-pointer font-medium"> SmartNoise</a> 
          and <a href="https://github.com/IBM/differential-privacy-library" target={"__blank"} className="text-blue-700 hover:text-blue-900 cursor-pointer font-medium"> DiffPrivLib</a>. See how they work and how you can use them in the competition. Live Q&A.
        </p>
    },
    {
      date: "5th November 2022",
      title: "Registration Closes",
      links: true,
      description:"This is the last day of registration! After this, the registrations are officially closed so hurry up and register if you haven't yet.",
      links_description: () => 
        <p>
          This is the last day of registration! After this, the registrations are officially closed so hurry up and
          <a href="#home" className="text-blue-700 hover:text-blue-900 cursor-pointer font-medium"> register</a> if you haven't yet.
        </p>,
      presentation: false,
      video: false,
    },
    {
      date: "8th November 2022",
      title: "Ready, set, go!",
      description:"The competition kicks off and will run for 3 days straight.",
      presentation: false,
      video: false,
    },
    {
      date: "11th November 2022",
      title: "Announcing Winners",
      description:"The competition closes and the winners will be announced.",
      presentation: false,
      video: false,
    },
  ];

  useEffect(()=>{
    const today = new Date();
    let flag = true;
    items.forEach((point, idx) => {
      let dateArr = point.date.split(" ");
      dateArr[0] = dateArr[0].substring(0, dateArr[0].length - 2);
      let pointDate = new Date(dateArr.join(" "));
      if(flag && pointDate.getMonth() === today.getMonth()){
        if(flag && pointDate.getDate() >= today.getDate()){
          setIndex(idx);
          flag = false;
        }
      }else if(flag && pointDate.getMonth() > today.getMonth()){
        setIndex(idx);
        flag = false;
      }
    })
  },[]);

  const handleBack = () => {
    sliderRef.current.slickPrev();
    setIndex(index - 1 <= 0 ? 0 : index - 1);
  };

  const handleNext = () => {
    sliderRef.current.slickNext();
    setIndex(index + 1 >= items.length - 1 ? items.length - 1 : index + 1);
  };

  return (
    <div className="sm:max-w-container max-w-[90vw] mx-auto relative z-10 mb-[150px]">
      {/* <img
        src={Misc2}
        className="absolute -bottom-10 left-[200px] translate-y-full"
        alt=":( Not Found"
      /> */}
      <div className="flex justify-between items-center sm:mb-[120px] gap-8 mb-10 flex-wrap">
        <div className="relative">
          <p className="font-semibold text-sm text-warning uppercase sm:mb-8 mb-4">
            timeline
          </p>
          <p className="font-semibold sm:text-[40px] text-4xl leading-[48px]">Key Dates</p>
          <img
            src={Misc1}
            className="absolute top-3 sm:right-0 right-[20%] translate-x-full"
            alt=":( Not Found"
          />
        </div>
        <div className="flex pl-10 ml-auto justify-between w-fit sm:scale-100 scale-[85%]">
          <div>
            <img
              className={`md:mx-3 mx-2 cursor-pointer ${
                index === 0 ? `opacity-20` : `opacity-100`
              }`}
              onClick={handleBack}
              src={Left}
              alt="previous"
            />
          </div>
          <div>
            <img
              className={`md:mx-3 mx-2 cursor-pointer ${
                index === items.length - 1 ? `opacity-20` : `opacity-100`
              }`}
              onClick={handleNext}
              src={Right}
              alt="next"
            />
          </div>
        </div>
      </div>
      <div>
        <Slider {...settings} ref={sliderRef}>
          {items.map((item, i) => (
            <div
              onClick={() => setIndex(i)}
              key={i}
              className={`pt-6 relative ${
                index === i || index + 1 === i ? `opacity-100` : `opacity-40`
              }`}
            >
              <span className="w-full border-t border-dashed border-t-[#14203820] absolute top-6 left-0"></span>

              <div className="w-[90%] mx-auto">
                <div className="h-[104px] relative">
                  <span className="sm:h-12 h-16 w-0 border-l border-dashed border-l-[#14203820] absolute sm:top-10 top-5 left-1/2 -translate-x-1/2"></span>
                  <div className="w-12 h-12 rounded-full border border-dark p-2 absolute left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white scale-75 sm:scale:100">
                    <span className="flex w-full h-full rounded-full bg-dark"></span>
                  </div>
                </div>
                <div className="w-full max-w-[420px] rounded-3xl px-8 py-12 bg-white shadow-slider-card">
                  <p className="font-semibold text-warning text-sm leading-5 mb-6 uppercase">
                    {item.date.substring(0, item.date.length - 4)}
                  </p>
                  <p className="font-semibold text-dark sm:text-2xl text-xl leading-normal mb-4">
                    {item.title}
                  </p>
                  <p className="text-dark sm:text-xl text-base leading-normal opacity-70">
                    {item?.links === true ? item.links_description() : item.description}
                  </p>
                  {i === index && (item.presentation || item.video) && (
                    <div className="mt-6">
                      {item.presentation && <p className="flex items-center mb-4">
                        <span className="font-semibold sm:text-base text-sm text-warning uppercase mr-2 underline cursor-pointer">
                          DOWNLOAD PRESENTATION
                        </span>
                        <img src={Download} alt="download" />
                      </p>}
                      {item.video && <span className="font-semibold sm:text-base text-sm text-dark uppercase underline cursor-pointer">
                        Play Video
                      </span>}
                    </div>
                  )}
                </div>
              </div>

            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Timeline;
